import React, { ReactNode } from "react";

import { useNavigate, useTranslation } from "utils";

import { Col, Link, Row, StickyFooter } from "components";

export type StickyFooterButtonsProps = {
  absolute?: boolean;
  children: ReactNode;
  handleBack?: () => void;
  extras?: ReactNode;
  backButtonLink?: string;
  size?: string;
  backButtonText?: string;
  mixpanelText?: string;
  className?: string;
  progressBarPercent?: number;
};

export const StickyFooterButtons = ({
  absolute = false, // set to true, in order to position the footer in a drawer, for example
  children,
  handleBack,
  extras,
  size = "tiniest",
  mixpanelText,
  backButtonLink,
  backButtonText = "",
  className,
  progressBarPercent,
}: StickyFooterButtonsProps) => {
  const { t } = useTranslation("modules");
  const navigate = useNavigate();

  const handleBackButtonClicked = () => {
    if (backButtonLink) {
      navigate(backButtonLink);
    } else if (handleBack) {
      handleBack();
    }
  };

  const showBackButton: string | (() => void) | undefined = handleBack || backButtonLink;

  return (
    <StickyFooter absolute={absolute} size={extras ? "" : size} className={className} progressBarPercent={progressBarPercent}>
      <>
        {extras && <div className="drawer-extras">{extras}</div>}

        <section className={`container ${size}`}>
          <Row align="middle" justify="center" style={{ width: "100%" }}>
            {/* prelint-ignore-col */}
            {showBackButton && (
              <Col sm={8} md={8}>
                <Link onClick={handleBackButtonClicked} mixpanelText={mixpanelText}>
                  {backButtonText || t("navigation.addModules.back")}
                </Link>
              </Col>
            )}
            <Col className="button-container" sm={showBackButton ? 16 : 24} md={showBackButton ? 16 : 24}>
              {children}
            </Col>
          </Row>
        </section>
      </>
    </StickyFooter>
  );
};
